// import clone from 'clone'
// import { initialState } from '../index'
import { RECEIPT_INIT_LOADING, RECEIPT_INIT_SUCCESS, RECEIPT_INIT_FAIL, RECEIPT_LOAD_DATA } from '@/store/types'

export const init = {
  [RECEIPT_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [RECEIPT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [RECEIPT_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [RECEIPT_LOAD_DATA] (state, data) {
    state.receiptData.branch = data.branch
    state.receiptData.acctNo = data.acctNo
    state.receiptData.type = data.type
    state.receiptData.docNo = data.docNo
    state.receiptData.fund = data.fund
    state.receiptData.suffix = data.suffix
    state.receiptData.tranMode = data.tranMode
  }
}
